module.exports = __webpack_public_path__ + "img/select-empty-store.dd26b3ea.png";